import { injectable } from 'inversify';
import 'reflect-metadata';
import axiosClient from '@/_shared/services/axios-client';
import {
  CategoryFolderBreadcrumbItem,
  CategoryFolderContentsResult,
  CategoryFolderContentsSortBy,
  CategoryFolderContentsSortDirection,
} from '@/_shared/models/category-folders.models';
import { ApiResponse } from '@/_shared/utils/api-response.utils';

export interface GetCategoryFolderContentsRequest {
  folderId?: string | null;
  sortBy?: CategoryFolderContentsSortBy;
  sortDirection?: CategoryFolderContentsSortDirection;
  offset?: number;
  limit?: number;
}

@injectable()
export class CategoryFoldersService {
  async getFolderContents({
    folderId = null,
    sortBy,
    sortDirection,
    offset = 0,
    limit = 10,
  }: GetCategoryFolderContentsRequest = {}): Promise<
    ApiResponse<CategoryFolderContentsResult>
  > {
    const endpoint = folderId
      ? `/api/category-insights/folders/${folderId}`
      : '/api/category-insights/folders';

    const response = await axiosClient.get<
      ApiResponse<CategoryFolderContentsResult>
    >(endpoint, {
      params: {
        sortBy,
        sortDirection,
        offset,
        limit,
      },
    });

    return response.data;
  }

  async getFolderBreadcrumbs(
    folderId: string
  ): Promise<ApiResponse<{ items: CategoryFolderBreadcrumbItem[] }>> {
    const response = await axiosClient.get<
      ApiResponse<{ items: CategoryFolderBreadcrumbItem[] }>
    >(`/api/category-insights/folders/${folderId}/breadcrumbs`);

    return response.data;
  }
}
